import BasePropertyTabView      from 'properties/BasePropertyTabView';
import propertyViewMapService   from 'PropertyViewMapService.js';
import formModel 		        from 'formModel.js'
import listService              from 'ListService';
import contentTemplate          from 'properties/tab-settings-view.ejs';
import Immutable                from 'immutable';
import constants        from 'Constants';

class TabSettingsView extends BasePropertyTabView {

    initialize( opts ) {
        this.options = opts || {};

        this.tagName = 'div';
        this.id = '#settings';
        this.factoryKey = opts.factoryKey;
        this.displayControlName = opts.controlName;  

        super.initialize(opts);

        this.template = contentTemplate;

        //used in Table Columns 
        if (this.factoryKey === undefined) {
            this.factoryKey = this.model.attributes.factoryKey;
        }
        this.model.set('altFactoryKey', this.factoryKey, {silent:true});

        return this;
    } 

    render(opts) { 
        this.factoryKey = this.model.attributes.factoryKey;
        this.displayControlName = this.model.get('name');
        this.multipleSelected = (opts && opts.multipleSelected) || listService.selectedCount > 1;

        if (opts && opts.factoryKey) {
            this.factoryKey = opts.factoryKey;
            this.displayControlName = opts.controlName;
        }

        var views = []; 

        this.layout = formModel.get('currentDevice');


        /*TODO: PF-3314
        **** We should adapt this to the mobile stuff ...
        *    Once our scope is finally defined.
        *    this is just "|| listService.mainKind === 'M'" to make  the props panel work.
        *
        ****/ 
        if (this.layout === 'deviceDesktop') {
            // Render Property Views
            if (this.multipleSelected) {
                views = propertyViewMapService.getMultipleSelectedSettingsViews();
                this.model = listService.combineSelectedModels();
                this.model.set('factoryKey', '', {silent: true});
                this.model.set('displayControlName', '', {silent: true});
                this.model.set('controlName', '', {silent: true});
                // PF-1891: Grabbin all factorykeys from multiselection for further reference

                const allKeys = listService.selected.map((obj, index) => obj.model.get('factoryKey'));

                this.model.set('factoryKeys', allKeys, {silent: true});
            } else {                
                views = propertyViewMapService.getSettingsViews(this.factoryKey);
            }
            this.model.set('displayMode', '', {silent: true});
        }

        if(listService.mainKind === constants.KIND_MOBILE){
            views = propertyViewMapService.getSettingsMobileViews(this.factoryKey);
        }

        if (this.layout === 'deviceTablet') {
            // Render Property Views
            views = propertyViewMapService.getSettingsTabletViews(this.factoryKey);
            this.model.set('displayMode', '- Tablet', {silent: true});
        }

        if (this.layout === 'devicePhone') {
            // Render Property Views
            views = propertyViewMapService.getSettingsPhoneViews(this.factoryKey);
            this.model.set('displayMode', '- Phone', {silent: true});
        }

        if (this.displayControlName === undefined) {
            this.model.set('displayControlName', this.model.attributes.controlName, {silent:true});
        } else {
            this.model.set('displayControlName', this.model.get('name'), {silent:true});
        }

        const accessibilityOnTop = Immutable.Set(['control_pie_chart', 'control_value','control_bar_chart', 'control_line_chart', 'control_data_grid', 'control_gauge_chart','control_filter_input', 'control_filter_selector']);
        this.model.set('accessibilityOnTop', accessibilityOnTop , {silent:true});

        this.clearPropertyViews();
        
        //PF-2607 sometimes in the version deployed this line is not executed 
        //According with backbone docs there is a better way to call extended function than super.render();
        //for more info go to http://backbonejs.org/#Model-extend
        BasePropertyTabView.prototype.render.call(this);

        this.renderPropertyViews(views, this.model); 

        return this;
    }

}

export default TabSettingsView;
